import { Component, computed, effect, inject, Signal } from '@angular/core';
import { CompanyProjectItemComponent } from '@app/components/company/company-projects/company-project-item/company-project-item.component';
import { UiButtonComponent } from '@app/shared/ui/button/ui-button.component';
import { UiSpinnerDirective } from '@app/shared/ui/spinner/ui-spinner.directive';

import { ProjectActionsService } from '@app/shared/services/actions/project-actions.service';
import { ActiveCompanyService } from '@app/shared/services/active-company.service';
import { ActiveProjectService } from '@app/shared/services/active-project.service';
import { ProjectsDataService } from '@app/shared/services/projects-data.service';
import { DialogService } from '@app/shared/services/shared/dialog.service';
import { Project } from '@app/shared/types/models/project/project.model';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'proffeo-company-active-projects-view',
  templateUrl: './company-active-projects-view.component.html',
  imports: [CompanyProjectItemComponent, TranslatePipe, UiButtonComponent, UiSpinnerDirective]
})
export class CompanyActiveProjectsViewComponent {
  private readonly projectService: ProjectsDataService = inject(ProjectsDataService);
  private readonly activeCompanyService: ActiveCompanyService = inject(ActiveCompanyService);
  private readonly dialogService: DialogService = inject(DialogService);
  private readonly projectActionsService: ProjectActionsService = inject(ProjectActionsService);
  private readonly activeProjectService: ActiveProjectService = inject(ActiveProjectService);

  protected readonly activeCompanyProjects: Signal<Project[]> = computed(() =>
    this.projectService.getCompanyProjects(this.activeCompanyId())()
  );
  protected readonly activeProjectId: Signal<string> = this.activeProjectService.activeProjectId;
  protected activeCompanyId: Signal<string | undefined> = this.activeCompanyService.activeCompanyId;

  public constructor() {
    effect(() => {
      const companyId = this.activeCompanyId();
      if (companyId) {
        this.projectService.loadCompanyProjects(companyId);
      }
    });
  }

  protected setActiveProject(project: Project): void {
    void this.activeProjectService.setActiveProject(project);
  }

  protected archiveProject(project: Project): void {
    const companyId = this.activeCompanyId();
    if (companyId) {
      this.projectService.archiveProject(project, companyId);
    }
  }

  protected openCreateCompanyProjectDialog(): void {
    this.dialogService.openCreateCompanyProjectDialog();
  }

  protected openEditCompanyProjectDialog(project: Project): void {
    this.dialogService.openEditCompanyProjectDialog(project, false);
  }

  protected onExportTaskImportTemplate(project: Project): void {
    this.projectActionsService.exportTaskImportTemplate(project);
  }
}
